"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    extractArgTypeCombinations: ()=>extractArgTypeCombinations
});
const PROPS_TO_SKIP = [
    'children',
    'className',
    'onClick',
    'onHover',
    'ariaLabel',
    'loading',
    'emphasis',
    'slots',
    'id'
];
function extractArgTypeCombinations(defaultArgs, argTypes, applySkipList = true) {
    return Object.entries(argTypes).reduce((acc, [key, value])=>{
        if (applySkipList) {
            if (PROPS_TO_SKIP.includes(key)) return acc;
        }
        if ('iconLeft' === key || 'iconRight' === key || 'iconName' === key) {
            const x = {
                propName: key,
                props: [
                    {
                        ...defaultArgs,
                        [key]: 'date_range'
                    }
                ]
            };
            return [
                ...acc,
                x
            ];
        }
        if (Array.isArray(value?.type?.value) && 2 === value.type.value.length && value.type.value.includes('true') && value.type.value.includes('false')) {
            const x = {
                propName: key,
                props: [
                    true,
                    false
                ].map((option)=>({
                        ...defaultArgs,
                        [key]: option
                    }))
            };
            return [
                ...acc,
                x
            ];
        }
        if (value.control?.type === 'select') {
            const x = {
                propName: key,
                props: value.options.map((option)=>({
                        ...defaultArgs,
                        [key]: option
                    }))
            };
            return [
                ...acc,
                x
            ];
        }
        if (value.control?.type === 'radio') {
            const x = {
                propName: key,
                props: value.options.map((option)=>({
                        ...defaultArgs,
                        [key]: option
                    }))
            };
            return [
                ...acc,
                x
            ];
        }
        return acc;
    }, []).sort((a, b)=>a.propName.localeCompare(b.propName));
}
exports.extractArgTypeCombinations = __webpack_exports__.extractArgTypeCombinations;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "extractArgTypeCombinations"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
